import { useMediaQuery } from "@mui/material";

const MIN = 0;
const MAX = 750;

const portraitMediaQuery = `(orientation: portrait) and (${MIN}px <= width <= ${MAX}px)`;
const landscapeMediaQuery = `(orientation: landscape) and (${MIN}px <= height <= ${MAX}px)`;

const mobileMediaQuery = [portraitMediaQuery, landscapeMediaQuery].join(", ");

export function useIsMobile(): boolean {
  return useMediaQuery(mobileMediaQuery, { noSsr: true });
}

const widthMediaQuery = `(${MIN}px <= width <= ${MAX}px)`;

export function useIsConstrainedWidth(): boolean {
  return useMediaQuery(widthMediaQuery, { noSsr: true });
}

const heightMediaQuery = `(${MIN}px <= height <= ${MAX}px)`;

export function useIsConstrainedHeight(): boolean {
  return useMediaQuery(heightMediaQuery, { noSsr: true });
}
